import React from 'react';
import styled from "styled-components";
import HobbyPage from "../components/HobbyPage";
import Logo from "../assets/logoZT.png";
import CodePortfolio from "../components/CodePortfolio";

function Hobbies () {

    return (

        <div>
            <CodePortfolio
                image={Logo}
                title="Foodie App"
                description="For my end project FE developer at NOVI Hogeschool
                I needed to build a fully working web app. In this app I made a
                connection with a database (Firebase) for user management and
                several API connections to give the user some nice features.
                Some of the features: search, filter on healthy elements and
                a handy shopping list for the needed ingredients.

                The design and technical decisions are 100% mine."
            />
        </div>

    );
}

export default Hobbies ;